// extracted by mini-css-extract-plugin
export default {"icon":"Icon_icon__N-pwR","spin":"Icon_spin__IPdfL"};